import { render } from "./ConfidenceLabel.vue?vue&type=template&id=0acbbf3c&ts=true"
import script from "./ConfidenceLabel.vue?vue&type=script&lang=ts"
export * from "./ConfidenceLabel.vue?vue&type=script&lang=ts"

import "./ConfidenceLabel.vue?vue&type=style&index=0&id=0acbbf3c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__